export function getFileExtension(fileName: string): string {
  return fileName.split(".").at(-1)?.toLowerCase() || "";
}
